export default "__VITE_ASSET__BPy4XZOs__"